import useAppStore from "@/store/app";
import URL, { ApiBaseUrl } from "@/services/urls";
import axios, { CreateAxiosDefaults } from "axios";
import { debug } from "@/log";

const config: CreateAxiosDefaults = {
  baseURL: ApiBaseUrl(),
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Credentials': 'false'
  }
};
const HTTP = axios.create(config);

const Post = HTTP.post;
const Get = HTTP.get;
const Delete = HTTP.delete;
const Put = HTTP.put;

export function watchToken(cwToken: string, fresh: boolean) {
  const savedCwToken = cwToken || useAppStore().token;

  HTTP.defaults.headers.common['cwtoken'] = savedCwToken;
  // first time loading
  if (savedCwToken) {
    useAppStore().boot(savedCwToken, fresh);
  }

  // after each mutation(something in the state changed)
  useAppStore().$subscribe((mutation, { cwToken }) => {
    //debug("cwToken changed to " + cwToken);
    useAppStore().boot(cwToken, false);
    HTTP.defaults.headers.common['cwtoken'] = cwToken ?? '';
  });
}
export { Post, Get, Delete, Put }
